import { combineReducers } from 'redux';
import HubReducer from './modules/Hub/Reducers/HubReducer';
import AuthReducer from './services/Auth/AuthReducer';

const rootReducer = combineReducers({
  HubReducer,
  AuthReducer,
});

export default rootReducer;
